import type { InputHTMLAttributes, ReactElement } from 'react';

import { cn } from '../lib/cn.js';
import { UNDERLINE_INPUT_CLS } from '../lib/underline.js';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

// A bare text input on the shared underline — the search boxes and one-offs.
// Labelled forms use the dashboard's UnderlineField, which wraps the same class.
export const Input = ({ className, type = 'text', ...props }: InputProps): ReactElement => (
  <input type={type} className={cn(UNDERLINE_INPUT_CLS, className)} {...props} />
);
